import React, { useEffect, useState } from "react";
import { Segmented, Tag } from "antd";
import cartService, { Cart } from "../../../../Service/cart.service";
import PlanCard from "./PlanCard";
import { useAppContext } from "../../../../Context/AppContext/AppContext";
import { useLoader } from "../../../../Context/LoaderContext";
import { TransformedPlan } from "../../../../Interface";
import { Plan } from "../../../../Entities/Plan";
import useOrganization from "../../../../Hooks/useOrganization";
import { transformPlanData } from "../../../../Utils/planUtils";
import { Subscription } from "../../../../Entities/Subscription";
import { StepKey } from "../../types";
import "./PlanListing.scss";

interface PlanListingProps {
  userCart: Cart;
  handleStepChange: (step: StepKey) => void;
  activePlan: Plan | null;
  currentSubscription: Subscription | null;
}

const switchOptions = [
  {
    label: (
      <div className="annual-plan-label">
        <span>Annual</span>
        <Tag>Save 10%</Tag>
      </div>
    ),
    value: true,
  },
  { label: "Monthly", value: false },
];

const PlanListing: React.FC<PlanListingProps> = ({
  userCart,
  handleStepChange,
  activePlan,
}) => {
  const { plans, currentRegion } = useAppContext();
  const { setLoading, setLoadingMessage } = useLoader();
  const { org } = useOrganization();

  const [formattedPlans, setFormattedPlans] = useState<TransformedPlan[]>([]);

  const userCurrencyCode = currentRegion === "IND" ? "INR" : "USD";
  const userCurrencySymbol = currentRegion === "IND" ? "₹" : "$";

  const handleBillingTypeSwitch = (value: boolean) => {
    cartService.setBillingPeriod(value);
  };

  const formatPlans = (plans: Plan[]) => {
    const transformedPlans = transformPlanData(
      plans,
      org?._id || "",
      userCurrencyCode,
      userCurrencySymbol,
    );
    setFormattedPlans(transformedPlans);
  };

  useEffect(() => {
    if (plans.length === 0) {
      setLoading(true);
      setLoadingMessage("Loading plans...");
    } else {
      formatPlans(plans);
      setLoading(false);
      setLoadingMessage(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plans, org?._id]);

  return (
    <section className="plan-listing-container">
      <div className="billing-type-switch-container">
        <Segmented
          options={switchOptions}
          block
          onChange={handleBillingTypeSwitch}
          size="middle"
          value={userCart.basePlan.billedAnnually}
          className="custom-segmented"
        />
      </div>

      <div style={{ textAlign: "center" }}>
        <p
          style={{
            fontSize: "16px",
            color: "#666",
            maxWidth: "500px",
            margin: "0 auto",
          }}
        >
          Save <strong>10%</strong> with our annual subscription — charged
          annually.
        </p>
      </div>

      <div className="plan-listing-grid">
        {formattedPlans.map((plan, i) => {
          return (
            <PlanCard
              key={i}
              plan={plan}
              userCart={userCart}
              handleStepChange={handleStepChange}
              isCurrentPlan={activePlan?._id === plan._id}
              // onPlanSelect={onPlanSelect}
              // currentPlanId={currentPlanId}
            />
          );
        })}
      </div>
    </section>
  );
};

export default PlanListing;
